<template>
  <el-form-item :label="form.cname+':'"
    :key="form.key"
    :prop="prop"
    :rules="rule">
    <el-select v-if="status === 'edit'"
      style="width: 100%"
      multiple
      placeholder=""
      v-model="form.fieldValue">
      <el-option v-for="item in list"
        :key="item.certId"
        :label="item.certName"
        :value="item.certId">
      </el-option>
      <el-option :value="null">
        <el-button type="primary"
          @click.stop="create"
          style="width: 100%">新增</el-button>
      </el-option>
    </el-select>
    <span v-else>{{name}}</span>
    <certificate-modal ref="modal"
      :vendorId="vendorId"
      :fetch="fetchList" />
  </el-form-item>
</template>

<script>
import CertificateModal from '@/page/certificate/certificate-modal.vue'
export default {
  name: 'cert-form-select',
  components: { CertificateModal },
  props: {
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    },
    vendorId: [String, Number]
  },
  data () {
    return {
      list: []
    }
  },
  watch: {
    vendorId: {
      handler (val, oldVal) {
        if (val) {
          this.fetchList()
        }
      },
      immediate: true
    }
  },
  computed: {
    form: {
      get () {
        return this.item
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name () {
      let names = this.list.filter(o => this.form.fieldValue.indexOf(o.certId) > -1)
      return names.map(o => o.certName).join('，')
    },
    rule () {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'change'
        }
      ]
    }
  },
  methods: {
    create () {
      this.$refs.modal.init({ vendorId: this.vendorId })
    },
    fetchList () {
      this.$store.dispatch('certificate/getcertificates', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          status: 3,
          vendorId: this.vendorId
        },
        success: (res) => {
          this.list = res.data.records.map(item => {
            item.certFile = item.certFile.split(',')[0]
            return item
          })
        },
        fail: () => { }
      })
    }
  }
}
</script>
